import React from 'react';
import {NodeProps, useReactFlow} from 'reactflow';

import {ProcessFlowchartNodeDetailsType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  TaskSchemaNodeData,
  TaskSchemaNodeSectionData,
} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';
import {BenchlingNodeV2} from 'ui-library/reactflow/nodes/BenchlingNode/v2/BenchlingNode';

import createHeaderPropsForNode from './createHeaderPropsForNode';
import {getNodeStatusAndDescription} from './nodeUtils';
import {TaskSchemaNodeRowRenderer} from './TaskSchemaNodeRowRenderer';

export interface TaskSchemaNodeRendererProps extends NodeProps<TaskSchemaNodeData> {}

export default function TaskSchemaNodeRenderer(props: TaskSchemaNodeRendererProps): JSX.Element {
  const {data, xPos, yPos, id} = props;
  const reactFlowInstance = useReactFlow();
  const {sections, onNodeHeaderClick} = data;

  const headerProps = createHeaderPropsForNode(
    {
      ...data,
      position: {x: xPos, y: yPos},
    },
    reactFlowInstance,
    data.nodeDetailsType !== ProcessFlowchartNodeDetailsType.ROOT_NODE_DETAILS,
    data.nodeDetailsType !== ProcessFlowchartNodeDetailsType.OUTPUT_NODE_DETAILS
  );

  const handleHeaderClick = (): void => {
    onNodeHeaderClick?.(id);
  };

  const {status, description} = getNodeStatusAndDescription(data.validationErrors);

  return (
    <BenchlingNodeV2 isSelected={props.selected} status={status} statusDescription={description}>
      {headerProps && (
        <BenchlingNodeV2.Standard.Header
          {...headerProps}
          onClick={handleHeaderClick}
          style={{
            cursor: onNodeHeaderClick != null ? 'pointer' : 'default',
          }}
        />
      )}
      {sections && (
        <BenchlingNodeV2.Sections>
          {sections.map((section: TaskSchemaNodeSectionData) => (
            <BenchlingNodeV2.Section key={section.sectionName} name={section.sectionName}>
              {section.sectionRows.map((row) => (
                <TaskSchemaNodeRowRenderer key={row.id} {...row} />
              ))}
            </BenchlingNodeV2.Section>
          ))}
        </BenchlingNodeV2.Sections>
      )}
    </BenchlingNodeV2>
  );
}
